import React, { useContext } from 'react';
import { Dialog, DialogContent, DialogActions, Button, Box, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ToolContext } from '../../../../../core/context/ToolContext';
import { rqx } from '../../../../../core/request/API';
import { env } from '../../../../../core/Env';
import { SnakeLoader } from '../../../../../core/loader/SnakeLoader';

export const ProfilesAndPages = () => {
    const { tool_state, social_media_insight_state } = useContext(ToolContext);
    const { userId } = tool_state;
    const url = new URL(window.location.href);
    const stateParam = url.searchParams.get('state')?.toLocaleLowerCase();
    const profiles = social_media_insight_state.profilePages.data;

    const onClose = () => {
        social_media_insight_state.showProfilesModal.set(false);
        social_media_insight_state.insightLoading.set(true);
        social_media_insight_state.topContentsLoading.set(true);
        social_media_insight_state.viewsLoading.set(true);
        social_media_insight_state.followsLoading.set(true);
        social_media_insight_state.reachLoading.set(true);
        social_media_insight_state.linkClicksLoading.set(true);
        // Trigger data reload by updating urlCode
        // social_media_insight_state.urlCode.set(`${social_media_insight_state.connectedPlatform.data} connection code`);
    }

    const filteredProfiles = profiles.filter(profile =>
        profile.page_name.toLowerCase().includes(social_media_insight_state.searchQuery.data.toLowerCase())
    );

    const handleConnect = async () => {
        try {
            let bdy = { user_id: userId.data, page_id: social_media_insight_state.selectedProfileId.data };
            await rqx.post(`<<tool>>/${env()}/${stateParam}Insights/select_${stateParam}_page`, bdy);
            social_media_insight_state.selectedPlatform.set(String(stateParam).charAt(0).toUpperCase() + String(stateParam).slice(1));
            social_media_insight_state.connectedPlatform.set(stateParam);
            social_media_insight_state?.urlCode?.set(`${stateParam} connection code`);
            console.log("Handle connect called from profiles and pages component !!")
            onClose();
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <Dialog
            open={social_media_insight_state.showProfilesModal.data}
            PaperProps={{
                style: {
                    borderRadius: '10px',
                    width: '100%',
                    maxWidth: '768px',
                    margin: "0 20px",
                }
            }}
        >
            <Box display="flex" alignItems="center" justifyContent="space-between" px={3} py={3} sx={{
                borderBottom: "1px solid rgb(0 0 0 / 10%)",
            }}>
                <Box sx={{
                    fontSize: { xs: "18px", md: "24px", },
                    fontWeight: 700,
                    lineHeight: { xs: "24px", md: "32px", },
                }}>
                    Your profiles & Pages
                </Box>
            </Box>
            <DialogContent sx={{ padding: "24px 0 24px" }}>
                <Box
                    mb={3}
                    display="flex"
                    alignItems="center"
                    sx={{
                        background: '#fff',
                        border: '1px solid #F2F2F2',
                        borderRadius: '8px',
                        margin: "0 24px 24px 24px",
                        height: "52px",
                        boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                    }}
                >
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bgcolor="#fff"
                        sx={{
                            width: "52px",
                            height: "51px",
                            borderRight: "1px solid #F2F2F2",
                            boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.1)",
                        }}>
                        <svg width="20" height="20" fill="none">
                            <circle cx="9" cy="9" r="7" stroke="#8D98A4" strokeWidth="2" />
                            <path d="M17 17L13.5 13.5" stroke="#8D98A4" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </Box>
                    <TextField
                        fullWidth
                        placeholder="Search profiles and pages"
                        variant="standard"
                        value={social_media_insight_state.searchQuery.data}
                        onChange={(e) => social_media_insight_state.searchQuery.set(e.target.value)}
                        InputProps={{
                            disableUnderline: true,
                            style: {
                                background: 'transparent',
                                color: '#222',
                                padding: "0 16px",
                            }
                        }}
                        sx={{
                            '& .MuiInputBase-input': {
                                fontSize: { xs: "14px", md: "16px" },
                                lineHeight: { xs: "20px", md: "24px" },
                            }
                        }}
                    />
                </Box>
                <Box>
                    {filteredProfiles.length !== 0 ?
                        filteredProfiles.map((profile, idx) => {
                            const selected = social_media_insight_state.selectedProfileId.data === profile.page_id;
                            return (
                                <Box
                                    key={profile.page_id}
                                    display="flex"
                                    alignItems="center"
                                    px={3}
                                    py={2}
                                    sx={{
                                        cursor: 'pointer',
                                        background: selected ? 'rgba(16, 108, 54, 0.05)' : 'transparent',
                                        borderBottom: "1px solid #F2F2F2",
                                        transition: 'background 0.2s, border 0.2s',
                                        '&:hover': {
                                            background: 'rgba(16, 108, 54, 0.05)'
                                        }
                                    }}
                                    onClick={() => social_media_insight_state.selectedProfileId.set(profile.page_id)}
                                >
                                    <img
                                        src={profile?.logo}
                                        alt={profile?.page_name?.trim()?.toLowerCase()}
                                        style={{
                                            width: 54,
                                            height: 54,
                                            borderRadius: '8px',
                                            marginRight: 16,
                                            border: selected ? '1px solid #106C36' : '1px solid #F2F2F2',
                                            padding: "5px",
                                        }}
                                    />
                                    <Box
                                        flex={1}
                                        fontWeight={selected ? 600 : 400}
                                        color={selected ? '#106C36' : '#000000'}
                                        fontSize={{ xs: "14px", md: "16px", }}
                                        lineHeight={{ xs: "20px", md: "24px", }}
                                    >
                                        {profile?.page_name}
                                    </Box>
                                    {selected && (
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            width={32}
                                            height={32}
                                            borderRadius="50%"
                                        >
                                            <svg width="24" height="24" fill="none">
                                                <circle cx="12" cy="12" r="12" fill="#106C36" />
                                                <path d="M7 12.5l3 3 6-6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </Box>
                                    )}
                                </Box>
                            );
                        })
                        :
                        social_media_insight_state.profilePagesLoading.data ? (
                            <Box sx={{ 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center', 
                                height: '300px', 
                                width: '100%', 
                                fontSize: '14px', 
                                fontWeight: '600',
                                color: '#666'
                            }}>
                                <SnakeLoader size="1rem" bg="#11783C" distance="0.3rem" />
                            </Box>
                        ) : <Box display="flex" justifyContent="center" alignItems="center">
                            No pages found
                        </Box>
                    }
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 0 }}>
                <Button
                    variant="contained"
                    onClick={handleConnect}
                    sx={{
                        borderRadius: '10px',
                        textTransform: 'none',
                        bgcolor: '#333333',
                        '&:hover': {
                            bgcolor: '#444444'
                        }
                    }}
                    disabled={!social_media_insight_state.selectedProfileId.data}
                >
                    Submit
                </Button>
            </DialogActions>
        </Dialog >
    );
};
